import config from '@/config';
import {ApiBase, ListOptions} from '@/api/common';
import ApiList from '@/api/list';

const NO_UPLOAD_FIELDS = [
    'audio_path',
    'audio_link',
    'audio_file',
    'audio_alt_path',
    'audio_alt_link',
    'audio_alt_file',
    'state',
];

export default class Hint extends ApiBase<Hint> {
    public static readonly SLUG: string = 'hint';
    private static readonly URL_BASE: string = config.API_ROOT + '/hint/';
    
    // Initializing these fields (even with undefined)
    // is necessary, so hasOwnAttribute can find them.
    public audio?: number = undefined;
    public audio_path?: string = undefined;
    public audio_link?: string = undefined;
    public audio_alt?: number = undefined;
    public audio_alt_path?: string = undefined;
    public audio_alt_link?: string = undefined;
    public language?: string = undefined;
    public text?: string = undefined;
    public parent_id?: number = undefined;
    public parent_model?: string = undefined;
    
    // used to store the files before the hint is uploaded
    // null means the user deleted the current image and did not replaced it
    public audio_alt_file?: File|null = undefined;
    public audio_file?: File|null = undefined;
    
    // currently unused
    public spreadsheet?: string = undefined;
    
    // used to know if the hint is being created, was updated or is saved
    public state?: string = 'created';
    
    public constructor() {
        super({
            urlBase: Hint.URL_BASE,
            filteredFields: NO_UPLOAD_FIELDS,
        });
    }
    
    public assign(response: any): Hint {
        super.assign(response);
        this.state = 'unchanged';
        return this;
    }
}
